module.exports = __webpack_public_path__ + "static/media/burger-logo.f5fb982c.jpg";